import { cn } from '@/lib/utils';

// The table draws the column rules and the padding; a cell only lays out what it holds.
export const Cell = ({ className, children }: { className?: string; children?: React.ReactNode }) => (
  <div className={cn('relative flex h-full items-center', className)}>{children}</div>
);
